export default __webpack_public_path__ + "static/media/3.61cd7a81.jpg";